import { ChargePointLog } from '../../../../../../../app/ApiGen';
import { Normalised } from '../../../../../../../utils/request';

export type ConnectionChartData = Datum & {
  type: string;
};

type Datum = { y: string; x: [number, number] };

const getServerEventTime = (log: Normalised<ChargePointLog>): number => new Date(log.serverEventDate).getTime();

const getXValues = (args: {
  log: Normalised<ChargePointLog>;
  index: number;
  logs: Normalised<ChargePointLog>[];
  now: Date;
}): Datum['x'] | undefined => {
  const { index, log, logs, now } = args;

  const logEventTime = getServerEventTime(log);

  const isLastLog = index === logs.length - 1;
  if (isLastLog) {
    return [logEventTime, now.getTime()];
  }

  const nextDistinctWebSocketLog = logs.findIndex((value) => {
    const occurredAfterCurrentLog = getServerEventTime(value) > logEventTime;
    return value.eventType !== log.eventType && occurredAfterCurrentLog;
  });

  return nextDistinctWebSocketLog !== -1
    ? [logEventTime, getServerEventTime(logs[nextDistinctWebSocketLog])]
    : undefined;
};

export const getWebsocketChartDataset = (logs: Normalised<ChargePointLog>[], now: Date): ConnectionChartData[] =>
  logs
    .filter((log) => log.eventType === 'WebSocketConnection' || log.eventType === 'WebSocketClose')
    .reduce<ConnectionChartData[]>((acc, log, index, arr) => {
      const x = getXValues({ log, logs: arr, index, now });
      return x
        ? [...acc, { x, y: '1', type: log.eventType === 'WebSocketConnection' ? 'Connection' : 'Disconnection' }]
        : acc;
    }, [])
    .sort((a, b) => a.type.localeCompare(b.type));
